import { ofType, combineEpics, type Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import Safescarf from '../../../api/safescarf';
import { handleError } from '../../errorHandler';

import {
  CREATE_SAFESCARF_USER_STARTED,
  createUserFulfilled,
  FETCH_SAFESCARF_USERS_STARTED,
  fetchUsersFulfilled,
  UPDATE_SAFESCARF_USER_STARTED,
  updateUserFulfilled,
} from './actions';

const createUserEpic: Epic = action$ =>
  action$.pipe(
    ofType(CREATE_SAFESCARF_USER_STARTED),
    mergeMap((action: { payload: unknown }) =>
      from(Safescarf.createSafescarfUser(action.payload as Record<string, unknown>)).pipe(
        mergeMap((response: { data: unknown }) => of(createUserFulfilled(response.data))),
        catchError(handleError)
      )
    )
  );

const fetchUsersEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_SAFESCARF_USERS_STARTED),
    mergeMap((action: { payload: Record<string, unknown> }) =>
      from(Safescarf.fetchSafescarfUsers(action.payload)).pipe(
        mergeMap((response: { data: unknown }) => of(fetchUsersFulfilled(response.data))),
        catchError(handleError)
      )
    )
  );

const updateUserEpic: Epic = action$ =>
  action$.pipe(
    ofType(UPDATE_SAFESCARF_USER_STARTED),
    mergeMap((action: { payload: Record<string, unknown> & { id: string; } }) =>
      from(Safescarf.updateSafescarfUser(action.payload)).pipe(
        mergeMap((response: { data: unknown }) => of(updateUserFulfilled(response.data))),
        catchError(handleError)
      )
    )
  );

export default combineEpics(createUserEpic, fetchUsersEpic, updateUserEpic);
